const RUNTIME_CONFIG_GLOBAL = "__JUSTTRACKIT_RUNTIME_CONFIG__";

function normalizeValue(value) {
  return String(value || "").trim();
}

function shouldUseRuntimeConfig() {
  if (typeof window === "undefined") {
    return false;
  }

  if (import.meta.env.DEV) {
    return false;
  }

  const host = String(window.location.hostname || "").toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") {
    return false;
  }

  return true;
}

function readRuntimeConfig() {
  if (!shouldUseRuntimeConfig()) {
    return null;
  }

  if (typeof window === "undefined") {
    return null;
  }

  const candidate = window[RUNTIME_CONFIG_GLOBAL];
  if (!candidate || typeof candidate !== "object") {
    return null;
  }

  return candidate;
}

function readPublicConfig(key, fallbackValue = "") {
  const runtimeConfig = readRuntimeConfig();
  if (runtimeConfig && key in runtimeConfig) {
    const runtimeValue = normalizeValue(runtimeConfig[key]);
    if (runtimeValue) {
      return runtimeValue;
    }
  }

  return normalizeValue(fallbackValue);
}

export const PUBLIC_CONFIG = Object.freeze({
  API_BASE_URL: readPublicConfig("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
  // API_BEARER_TOKEN is a legacy escape hatch for non-Supabase auth setups.
  // Real users sign in via Supabase; their JWT is read from local/session storage.
  // Setting this in production would short-circuit JWT freshness checks, which
  // is why RequireAuth now also validates token exp before honoring it.
  API_BEARER_TOKEN: readPublicConfig("VITE_API_BEARER_TOKEN", import.meta.env.VITE_API_BEARER_TOKEN),
  AUTH_REFRESH_ENDPOINT: readPublicConfig(
    "VITE_AUTH_REFRESH_ENDPOINT",
    import.meta.env.VITE_AUTH_REFRESH_ENDPOINT
  ),
  SUPABASE_URL: readPublicConfig("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  SUPABASE_ANON_KEY: readPublicConfig(
    "VITE_SUPABASE_ANON_KEY",
    import.meta.env.VITE_SUPABASE_ANON_KEY
  )
});
